<h2 style="margin-top: 0; font-weight: bold; text-align: center;">{{data.title}}</h2>

<div class="messageDisplayerText">
    {{data.message}}
</div>
